var exports = {
  "u": "x936d19a0--88448e--section",
};

module.exports = exports;
